import { Component, Host, Input, AfterViewInit, ViewChild, TemplateRef, OnInit, inject, DestroyRef } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SbMapTooltipOptions } from './sb-map-tooltip-options';
import { AreaDTO } from 'src/app/services/api/api';
import { Polygon } from 'geojson';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sbMapTooltip, [sbMapTooltip]',
  templateUrl: './sb-map-tooltip.directive.html',
  styleUrls: ['./sb-map-tooltip.directive.scss'],
  standalone: false,
})
export class SbMapTooltipDirective implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild('toolTipMapTemplate', { static: false }) template: TemplateRef<void>;

  @Input('sbMapTooltip') options: SbMapTooltipOptions;

  polygons: Polygon[];
  areas: AreaDTO[];
  coordinates: { x: number; y: number };

  opacity: number = 0.0;
  initialZoom: number = 13;

  constructor(@Host() private readonly ngbTooltip: NgbTooltip) {}

  ngOnInit() {
    if (this.options) {
      switch (this.options.type) {
        case 'Polygon':
          this.polygons = this.options.data as Polygon[];
          break;
        case 'AreaDTO':
          this.areas = this.options.data as AreaDTO[];
          break;
        case 'Coordinates':
          this.coordinates = this.options.data as { x: number; y: number };
          break;
      }
    }
  }

  ngAfterViewInit() {
    if (this.ngbTooltip) {
      this.ngbTooltip.ngbTooltip = this.template;
      this.ngbTooltip.hidden.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.hideMap();
      });
    }
  }

  showMap() {
    this.opacity = 1.0;
  }

  hideMap() {
    this.opacity = 0.0;
  }
}
